import type { Unsubscribe } from "@reduxjs/toolkit";
import { handleSetSelection, setSelection, handleToggleCheckout, toggleCheckout } from "./";
import { AppStartListening } from "..";

export function initWizardListeners(
  startListening: AppStartListening
): Unsubscribe {
  const subscriptions = [
    startListening({
      actionCreator: handleSetSelection,
      effect: async (action, { dispatch, getState }) => {
        const { payload } = action;
        const { wizard: { selection } } = getState();
        const newPayload = {
          ...selection
        };
        newPayload[payload.step] = payload.selection;        
        dispatch(setSelection(newPayload));
      },
    }),
    startListening({
      actionCreator: handleToggleCheckout,
      effect: async (action, { dispatch }) => {
        const { payload } = action;
        dispatch(toggleCheckout(payload));
      },
    }),
  ];
  return () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
  };
}
